import React from 'react';
import { Form } from 'semantic-ui-react';
import { ErrorMessage } from 'formik';
import InputMask from 'react-input-mask';
import FieldError from './FieldError';

const MaskedInputField = ({
  field: {
    name,
    value,
    onChange: handleChange,
    onBlur: handleBlur,
  },
  form: {
    touched,
    errors,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
  },
  label,
  mask,
  alwaysShowMask,
  ...props
}) => {
  // Use setFieldValue directly to avoid conflicts with react-input-mask
  const customHandleChange = (event) => {
    const { value: newValue } = event.target;
    setFieldValue(name, newValue);
  };

  const customHandleBlur = () => {
    setFieldTouched(name, true);
  };

  return (
    <>
      <Form.Field error={errors[name] && touched[name]}>
        <label htmlFor={`id-${name}`}>{label}</label>
        <InputMask
          id={`id-${name}`}
          name={name}
          value={value || ''}
          mask={mask}
          alwaysShowMask={alwaysShowMask}
          disabled={isSubmitting}
          onChange={customHandleChange}
          onBlur={customHandleBlur}
          {...props}
        />
      </Form.Field>
      <ErrorMessage name={name} component={FieldError} />
    </>
  );
};

export default MaskedInputField;
